<template>
  <div>
    <v-dialog v-model="value" scrollable persistent max-width="800px">
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn icon small @click="handleCancelSortCampaign">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 500px">
          <div v-if="loading" class="text-xs-center py-3">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else-if="campaigns.length == 0" class="text-xs-center py-3">No data</div>
          <template v-for="(campaign, index) in campaigns">
            <div :key="`campaign_${campaign.id}`">
              <v-layout>
                <v-flex shrink class="pa-2">
                  <MoveVertical
                    :index="index"
                    :max="campaigns.length"
                    :show-forward="true"
                    @onMove="onMove(campaign.id, $event)"
                  />
                </v-flex>
                <v-flex class="pa-2">
                  <div class="z-border-red pa-2">
                    <div style="display: flex; flex-direction: row; align-items: center">
                      <CampaignStatus :value="campaign.status_campaign" />
                      <div>{{ campaign.name }}</div>
                    </div>
                    <strong class="pa-1">Campaign Period / Time</strong>
                    <v-layout>
                      <v-flex class="form-control pa-1">
                        <input type="text" readonly :value="dateFormat(campaign.start_campaign)" />
                      </v-flex>
                      <v-flex class="form-control pa-1">
                        <input type="text" readonly :value="dateFormat(campaign.end_campaign)" />
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="handleCancelSortCampaign">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="handleSaveSortCampaign">
            {{ $t('Save') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'
import moment from 'moment'
import MoveVertical from '@/components/elements/MoveVertical'
import CampaignStatus from './CampaignStatus'
export default {
  components: {
    MoveVertical,
    CampaignStatus
  },
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
      loading: false,
      campaigns: [],
      total: 0
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.handleGetCampaign()
    this.loading = false
  },
  methods: {
    onMove(id, direction) {
      const index = this.campaigns.findIndex((campaign) => campaign.id.toString() == id.toString())
      if (index != -1) {
        const campaign = this.campaigns[index]
        const tmp_order = campaign.new_sort_order
        switch (direction) {
          case 'top':
            this.campaigns[index].new_sort_order = -1
            this.campaigns = this.handleSortCompaign().map((campaign, index) => ({
              ...campaign,
              new_sort_order: index + 1
            }))
            break
          case 'up':
            campaign.new_sort_order = this.campaigns[index - 1].new_sort_order
            this.campaigns[index - 1].new_sort_order = tmp_order
            this.campaigns = this.handleSortCompaign()
            break
          case 'down':
            campaign.new_sort_order = this.campaigns[index + 1].new_sort_order
            this.campaigns[index + 1].new_sort_order = tmp_order
            this.campaigns = this.handleSortCompaign()
            break
          case 'bottom':
            this.campaigns[index].new_sort_order = this.campaigns.length + 1
            this.campaigns = this.handleSortCompaign().map((campaign, index) => ({
              ...campaign,
              new_sort_order: index + 1
            }))
            break
        }
      }
    },
    dateFormat(date, format = 'DD/MM/YYYY HH:mm') {
      return format && date ? moment(date).format(format) : ''
    },
    async handleGetCampaign() {
      try {
        const response = await generaliApi.getCampaign({
          config: {
            params: {
              page_id: this.selectedBot.pageid,
              ...this.filter,
              status: ['Active', 'Publish'].join(',').toLowerCase(),
              sort_column: 'priority',
              sort: 'asc'
            }
          }
        })
        await handleResponse(response)
        this.total = response.data.total ? response.data.total : 0
        this.campaigns = response.data.data
          ? response.data.data.map((campaign, index) => ({
              ...campaign,
              start_campaign_date: campaign.start_campaign
                ? moment(campaign.start_campaign).format('YYYY-MM-DD')
                : null,
              start_campaign_time: campaign.start_campaign
                ? moment(campaign.start_campaign).format('HH:mm')
                : null,
              end_campaign_date: campaign.end_campaign
                ? moment(campaign.end_campaign).format('YYYY-MM-DD')
                : null,
              end_campaign_time: campaign.end_campaign
                ? moment(campaign.end_campaign).format('HH:mm')
                : null,
              new_sort_order: index + 1
            }))
          : []
      } catch (error) {
        handleApiError(error)
      }
    },
    handleSortCompaign() {
      return this.campaigns.sort((a, b) => {
        return a.new_sort_order - b.new_sort_order
      })
    },
    handleCancelSortCampaign() {
      this.$emit('input', false)
    },
    async handleSaveSortCampaign() {
      this.$store.dispatch('loading')
      for (let index = 0; index < this.campaigns.length; index++) {
        const campaign = this.campaigns[index]
        if (campaign.new_sort_order != campaign.priority) {
          await this.handleChangePriorityCampaign(campaign, campaign.new_sort_order)
        }
      }
      this.$store.dispatch('clear_loading')
      this.$swal.fire({
        title: this.$t('Successfully'),
        type: 'success',
        confirmButtonText: this.$t('Confirm'),
        reverseButtons: true
      })
      this.$emit('input', false)
    },
    async handleChangePriorityCampaign(campaign, priority) {
      try {
        const response = await generaliApi.putCampaign({
          config: {
            params: {}
          },
          data: {
            ...campaign,
            campaign_id: campaign.id,
            priority: priority
          }
        })
        await handleResponse(response)
        campaign.priority = priority
        return true
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/ListSort.vue